import { __read, __spreadArray, __values } from "tslib";
import * as React from 'react';
import cn from 'classnames';
import Header from './components/Header/Header';
import FormFields from './components/FormFields/FormFields';
import { useTheme } from '../../theme';
import { getPassengerDataLabel, getPassengerLabel, requiredFillData } from '../utils';
import { useForm, useFormState } from 'react-final-form';
import PopupWrapper from './components/PopupWrapper/PopupWrapper';
import { useMediaQuery } from 'react-responsive';
import { convertGenderToCorrectValue, MOBILE_MIN_WIDTH } from '../../utils';
import { fieldIsRequired, fieldsArrayToMap } from '../../Passenger/utils';
import WindowScope from './components/WindowScope/WindowScope';
import { Collapse } from '@material-ui/core';
import { DocTypes, Gender, TravellerFieldEnum } from '@websky/graphql';
import { Female, Male } from '../../Icons';
import { AdditionalTravellerFieldEnum, InputType } from '../../Passenger/types';
import { isSubsidyValidForPassenger } from '../../Checkout/store/subsidies/utils';
var PassengerForm = function (props) {
    var _a;
    var theme = useTheme('PassengerForm').PassengerForm;
    var change = useForm().change;
    var _b = useFormState(), values = _b.values, submitFailed = _b.submitFailed;
    var label = React.useMemo(function () { return getPassengerLabel(values.passengers[props.id], props.passengerType, props.supplierType); }, [props.fields, values]);
    var hasEmptyFieldsRequiredForSubsidies = React.useMemo(function () {
        var _a;
        return requiredFillData((_a = values === null || values === void 0 ? void 0 : values.passengers) === null || _a === void 0 ? void 0 : _a[props.id], values === null || values === void 0 ? void 0 : values.customer, props.fields, props.accompanyingFields, [
            props.fields.find(function (field) { return field.type === TravellerFieldEnum.DocNumber; })
        ]);
    }, [values, props.fields]);
    var docType = React.useMemo(function () { var _a; return (_a = values.passengers[props.id]) === null || _a === void 0 ? void 0 : _a.docType; }, [values, props.id]);
    var isFieldRequired = React.useMemo(function () { var _a; return requiredFillData((_a = values === null || values === void 0 ? void 0 : values.passengers) === null || _a === void 0 ? void 0 : _a[props.id], values === null || values === void 0 ? void 0 : values.customer, props.fields, props.accompanyingFields); }, [values, props.fields]);
    var subsidyFieldFactory = function (subsidy, disabled) {
        var _a;
        return ({
            selected: ((_a = values['passengers'][props.id]) === null || _a === void 0 ? void 0 : _a['subsidy']) === subsidy.id,
            name: 'subsidy',
            type: AdditionalTravellerFieldEnum.Subsidy,
            input: InputType.Select,
            subsidyType: subsidy.type,
            subsidyDisabled: disabled,
            value: subsidy.id,
            defaultValue: ''
        });
    };
    var numberIcon = React.useMemo(function () {
        var _a;
        if (props.isChangePassengers) {
            var gender = (_a = props.fields.find(function (field) { return field.type === TravellerFieldEnum.Gender; })) === null || _a === void 0 ? void 0 : _a.defaultValue;
            return gender ? (convertGenderToCorrectValue(gender) === Gender.Male ? Male : Female) : null;
        }
        return null;
    }, [props.fields, props.isChangePassengers]);
    var fields = React.useMemo(function () {
        var e_1, _a, e_2, _b;
        if (props.isChangePassengers) {
            var isPassport_1 = docType === DocTypes.Passport;
            return props.fields.filter(function (field) {
                if (field.type === TravellerFieldEnum.LinkedTraveller ||
                    field.type === TravellerFieldEnum.LoyaltyNumber) {
                    return false;
                }
                return !isPassport_1 || (isPassport_1 && field.type !== TravellerFieldEnum.DocExpiryDate);
            });
        }
        var resultFields = __spreadArray([], __read(props.fields), false);
        /**
         * добавляем поля с субсидиями
         * если не все required поля заполнены, добавляем субсидии со свойством subsidyDisabled: true
         * если все нужные заполнены и есть доступные субсидии - добавляем со свойством subsidyDisabled: false
         */
        if (hasEmptyFieldsRequiredForSubsidies) {
            var _loop_1 = function (availableSubsidy) {
                if (resultFields.some(function (field) { return field.subsidyType === availableSubsidy.type; })) {
                    return "continue";
                }
                resultFields.push(subsidyFieldFactory(availableSubsidy, true));
            };
            try {
                for (var _c = __values(props.availableSubsidies[props.id]), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var availableSubsidy = _d.value;
                    _loop_1(availableSubsidy);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else if (props.availableSubsidies[props.id]) {
            var _loop_2 = function (availableSubsidy) {
                var isSubsidyAvailable = isSubsidyValidForPassenger(values['passengers'][props.id], availableSubsidy);
                if (isSubsidyAvailable) {
                    resultFields = resultFields.filter(function (field) { return field.subsidyType !== availableSubsidy.type; });
                    resultFields.push(subsidyFieldFactory(availableSubsidy, false));
                }
                else {
                    if (resultFields.some(function (field) { return field.subsidyType === availableSubsidy.type; })) {
                        return "continue";
                    }
                    resultFields.push(subsidyFieldFactory(availableSubsidy, true));
                }
            };
            try {
                for (var _e = __values(props.availableSubsidies[props.id]), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var availableSubsidy = _f.value;
                    _loop_2(availableSubsidy);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return resultFields;
    }, [
        docType,
        props.fields,
        props.isChangePassengers,
        props.availableSubsidies,
        props.id,
        hasEmptyFieldsRequiredForSubsidies,
        (_a = values['passengers'][props.id]) === null || _a === void 0 ? void 0 : _a['subsidy']
    ]);
    var fieldsMap = React.useMemo(function () {
        return fieldsArrayToMap(fields);
    }, [fields]);
    var passengerFieldsMap = React.useMemo(function () {
        var _a;
        if (!isFieldRequired) {
            return getPassengerDataLabel((_a = values.passengers) === null || _a === void 0 ? void 0 : _a[props.id], fieldsMap);
        }
        return {};
    }, [isFieldRequired, values, fieldsMap]);
    React.useEffect(function () {
        if (!isFieldRequired) {
            props.onCorrectFilled(props.id);
        }
    }, [isFieldRequired]);
    var isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    var _c = __read(React.useState(false), 2), hasErrors = _c[0], setHasErrors = _c[1];
    var isOpened = isMobile && props.mobileOpenedPassengerId === props.id;
    var isReadonly = (props.isInputsReadonly || props.isReadonly) && !props.isChangePassengers;
    React.useEffect(function () {
        if (isMobile) {
            if (submitFailed && isFieldRequired && props.open) {
                setHasErrors(true);
                if (props.mobileOpenedPassengerId === null) {
                    props.onSetMobileOpenedPassengerId(props.id);
                }
            }
            else if (!isFieldRequired) {
                setHasErrors(false);
            }
        }
    }, [submitFailed, isMobile, isFieldRequired, props.open]);
    var onCloseHandler = function () { return props.onSetMobileOpenedPassengerId(null); };
    var onOpenHandler = function () { return props.onSetMobileOpenedPassengerId(props.id); };
    var onFillHandler = function (profile, type, fieldValue) {
        var _a, _b, _c, _d, _e, _f;
        if (type) {
            var docExpiryValidations = ((_a = props.fields.find(function (field) { return field.type === TravellerFieldEnum.DocExpiryDate; })) === null || _a === void 0 ? void 0 : _a.validations) || [];
            if ((type === TravellerFieldEnum.Nationality || type === TravellerFieldEnum.DocType) &&
                (((_c = (_b = values.passengers) === null || _b === void 0 ? void 0 : _b[props.id]) === null || _c === void 0 ? void 0 : _c.docExpiryDate) || ((_e = (_d = values.passengers) === null || _d === void 0 ? void 0 : _d[props.id]) === null || _e === void 0 ? void 0 : _e.nationality)) &&
                fieldIsRequired(values.passengers[props.id], docExpiryValidations)) {
                change("passengers[".concat(props.id, "].docExpiryDate"), '');
            }
        }
        (_f = props.onFill) === null || _f === void 0 ? void 0 : _f.call(props, profile, fieldValue);
    };
    return (React.createElement("div", { className: cn(theme.form, props.className), "data-passenger-type": props.passengerType, "data-passenger-id": props.id },
        React.createElement(WindowScope, { fieldsMap: fieldsMap, disabled: isReadonly },
            React.createElement(Header, { open: props.open, passengerId: props.id, label: label, numberIcon: numberIcon, onClick: onOpenHandler, correct: !isFieldRequired, passengerFieldsMap: passengerFieldsMap, showErrorNotice: hasErrors }),
            React.createElement(Collapse, { in: props.open },
                React.createElement(PopupWrapper, { inline: !isMobile, open: isOpened, onClose: onCloseHandler, correct: !isFieldRequired },
                    React.createElement(FormFields, { fields: fields, passengerId: props.id, passengerType: props.passengerType, passengerDocType: docType, selectedProfileId: props.selectedProfileId, label: label, inline: !isMobile, disabled: isReadonly, onTravellerSelect: onFillHandler, isAuthorized: props.isAuthorized, isChangeFiles: props.isChangeFiles, isChangePassengers: props.isChangePassengers, autofocus: props.autofocus, accompanyingFields: props.accompanyingFields, onSignUpLoyaltyProgram: props.onSignUpLoyaltyProgram, onSwap: props.onSwap, onToggleChangeFiles: props.onToggleChangeFiles, extraFieldsRender: props.extraFieldsRender }))))));
};
export default PassengerForm;
